export default "__VITE_ASSET__DG$0tvZb__"